import { type WorkerRequirementsIncludedDocumentsType } from "@clipboard-health/contract-worker-app-bff";
import { isNil } from "@clipboard-health/util-ts";

export function shouldShowRejectionReason(
  document: WorkerRequirementsIncludedDocumentsType | undefined
): boolean {
  if (isNil(document?.attributes)) {
    return false;
  }

  const { notification } = document.attributes;

  if (isNil(notification?.pushNotification)) {
    return false;
  }

  return notification.pushNotification;
}
